<template>
    <div style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;"
         v-select-text="value">
        <table width="100%" border="1" cellspacing="0" style="font-size: 14px;">
            <tbody>
            <tr>
                <th class="id62-p" width="50%">
                    Интернет-помощник «Перископ Он-Лайн»
                </th>
                <th class="id62-p">
                    Технический паспорт
                </th>
            </tr>
            <tr>
                <td class="id62-p">
                    Интернет-помощник (Перископ Он-Лайн)
                    Только осваиваете интернет и делаете первые шаги? Нужна помощь с подключением?<br>
                    «Перископ Он-Лайн» — отличный помощник для комфортного пользования связью.<br><br>
                    <strong>С его помощью вы сможете:</strong><br>
                    <ul style="margin-left: 20px;">
                        <li>
                            Легко и просто подключаться к Интернету!<br>
                            Создайте любое количество интернет-подключений, используя простую инструкцию.
                        </li>
                        <li>
                            Контролировать баланс денежных средств!<br>
                            С помощью «АИСТ Он-Лайн» удобно контролировать счета по услугам АИСТ.
                            Причем не только своих, но при необходимости и ваших родственников или друзей.
                            Необходимо лишь знание логина и пароля.
                        </li>
                        <li>
                            Узнавать новости компании интернет компании АИСТ в режиме «Он-Лайн»!<br>
                            Не обязательно заходить на сайт нашей компании, чтобы узнать последние новости. Достаточно
                            открыть «Перископ Он-Лайн», и вы сможете прочитать свежую новость компании или выбрать
                            интересующую новость из представленного списка.
                        </li>
                    </ul>
                </td>
                <td class="id62-p">
                    Новый удобный интерфейс «Перископ Он-Лайн» упрощает работу с программой и дает более наглядное
                    представление о потреблении вами услуг. Вы можете отслеживать историю подключений к сети Интернет,
                    смотреть графики расходования средств за интересующий вас период времени и многое другое.
                    <br>
                    <br>
                    <strong>Важно!</strong> В новостном окне программы предоставляется оперативная информация о
                    проводимых профилактических работах в сети компании.
                    <br>
                    <strong>Важно!</strong>
                    <br>
                    Необходимым условием работы программы является подключение к Интернет (способ подключения — любой).
                    <br>
                    Системные требования к вашему компьютеру:
                    <br>
                    Windows 2000/XP/7/8/10, 10 Мб дискового пространства.
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array, String]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped>
    .id62-p {
        padding: 10px 8px;
    }
</style>